import { Validateable } from "@models/interfaces";

export class OptInTermsSlider extends Validateable {
	public card_terms: boolean = false;
	public terms_and_conditions: boolean = false;
	public non_appropriate_user: boolean = false;
	public limit_orders: boolean = false;

	public wiggleCard(): void {
		this.wiggle("card_terms");
	}

	public wiggleTermsConditions(): void {
		this.wiggle("terms_and_conditions");
	}

	public nonAppropriateUser(): void {
		this.wiggle("non_appropriate_user");
	}

	public wiggleLimitOrders(): void {
		this.wiggle("limit_orders");
	}
}
